import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useGeneratePaymentReceipt(bookingCode: string) {
  return useMutation({
    mutationFn: async () =>
      apiMutation('POST', {
        path: ENDPOINTS.generatePaymentReceipt,
        params: { bookingCode },
      }) as Promise<void>,
    onSuccess: () => {
      message.success('New receipt successfully generated');
    },
    onError: () => {
      message.error('Failed to start receipt generation');
    },
  });
}
